module.exports = __webpack_public_path__ + "static/media/22.069209ac.jpg";